module.exports = __webpack_public_path__ + "static/media/side-bar-dasboard-icon-active.aa7bf9a8.svg";